import { Button } from "@repo/ui/components/Base/Button";
import { type UserImportData, UsersPreviewTable } from "../UsersPreviewTable";
import { DialogBody, DialogFooter } from "@repo/ui/components/Base/Dialog";

export interface UserImportFinishStepProps {
  previews: UserImportData[];
  totalRecords: number;
  importedRecords: number;
  onFinish: () => void;
}

export const UserImportFinishStep = ({
  previews,
  totalRecords,
  importedRecords,
  onFinish,
}: UserImportFinishStepProps) => {
  const duplicateRecords = previews.filter((u) => u.isDuplicate).length;
  const notValidRecords = previews.filter((u) => !u.isUserValid).length;
  return (
    <>
      <DialogBody className="flex flex-col gap-y-4">
        <p className="pt-3">
          Successfully imported {importedRecords} out of {totalRecords} records.
        </p>
        {notValidRecords > 0 && (
          <p>
            {notValidRecords}{" "}
            {notValidRecords === 1 ? "record was" : "records were"} not imported
            due to invalid data:
          </p>
        )}
        {duplicateRecords > 0 && (
          <p>
            {duplicateRecords} duplicate{" "}
            {duplicateRecords === 1 ? "record was" : "records were"} not
            imported because{" "}
            {duplicateRecords === 1
              ? "it was a duplicate"
              : "they are duplicates"}
            :
          </p>
        )}
        {previews.length > 0 && (
          <div className="flex flex-col">
            <UsersPreviewTable users={previews} error />
          </div>
        )}
      </DialogBody>
      <DialogFooter className="flex flex-row justify-end">
        <Button type="button" onClick={onFinish}>
          Finish
        </Button>
      </DialogFooter>
    </>
  );
};
